<script setup lang="ts">
/**
 * Display the information of a firmware
 * Trigger update event after fetched
 */
import type { Firmware } from "~/modules/firmware/models/Firmware.interface";
import ILxcInfo from "~icons/lxc/info";

const props = defineProps<{
  businessUnitCode?: number;
  organizationCode?: number;
  firmware?: Firmware | null;
}>();

const { t } = useI18n();

const emit = defineEmits(["update:firmware"]);

const computedFirmware = computed({
  get(): Firmware | undefined | null {
    return props.firmware;
  },
  set(firmware: Firmware | undefined | null) {
    emit("update:firmware", firmware);
  },
});

const hardwareVersions = computed(() =>
  computedFirmware.value?.hardwareVersions?.join(", "),
);
const firmwareVersions = computed(() =>
  computedFirmware.value?.firmwareVersions?.join(", "),
);
</script>

<template>
  <div v-if="computedFirmware" class="sticky bottom-0">
    <container-component :px="0" :py="0" :loader-size="14">
      <lxc-card body-class="!p-4">
        <div class="flex align-middle">
          <div class="border rounded-lg border-gray-300 p-2.5 self-center">
            <i-lxc-info class="text-gray-500" height="20" width="20" />
          </div>
          <div class="ms-3">
            <div class="font-semibold mb-1 text-gray-700">
              {{ t("firmware.firmwareInfo.compatibility.title") }}
            </div>
            <div class="font-normal text-gray-600">
              {{ t("firmware.firmwareInfo.compatibility.description") }}
            </div>
          </div>
        </div>
        <div class="flex gap-5 mt-3 mb-1">
          <div class="flex-1">
            <p class="text-gray-700">
              {{ t("firmware.firmwareInfo.equipmentTypeAttached") }}
            </p>
            <lxc-input
              v-model="computedFirmware.range"
              class="!bg-gray-50"
              label=""
              type="text"
              disabled
            />
          </div>
          <div class="flex-1">
            <p class="text-gray-700">
              {{ t("firmware.firmwareInfo.compatibleHardwareVersions") }}
            </p>
            <lxc-input
              v-model="hardwareVersions"
              class="!bg-gray-50"
              label=""
              type="text"
              disabled
            />
          </div>
          <div class="flex-1">
            <p class="text-gray-700">
              {{ t("firmware.firmwareInfo.compatibleFirmwareVersions") }}
            </p>
            <lxc-input
              v-model="firmwareVersions"
              class="!bg-gray-50"
              label=""
              type="text"
              disabled
            />
          </div>
        </div>
      </lxc-card>
    </container-component>
  </div>
</template>
